export default __webpack_public_path__ + "static/media/microsoft-azure.1dcce462.svg";